import type { SubAppErrors, SubAppPayload } from '@/types/sub-app-types'
import { computed, ref, type Ref } from 'vue'

export function useSubAppValidation(subApp: Ref<SubAppPayload>) {
  const submitted = ref(false)

  const errors = computed<Record<string, string>>(() => {
    const data = subApp.value
    const result: Partial<SubAppErrors> = {}

    if (!data.name?.trim()) result.name = 'Naam is verplicht'
    if (!data.customerId?.trim()) result.customerId = 'Klant is verplicht'
    if (!data.cluster?.trim()) result.cluster = 'Cluster is verplicht'
    if (!data.image) result.image = 'Afbeelding is verplicht'

    return result
  })

  const visibleErrors = computed<SubAppErrors>(() => {
    if (!submitted.value) return {}
    return errors.value
  })

  const isValid = computed(() => Object.keys(errors.value).length === 0)
  const isSubmittedAndInvalid = computed(() => submitted.value && !isValid.value)

  function validate(): boolean {
    submitted.value = true
    return isValid.value
  }

  return { errors, visibleErrors, isValid, isSubmittedAndInvalid, validate }
}
